import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargeLateFeeTypes = async ({
    token    
}) => {

    try {
        const res = await axiosCreate.get('/charge/late-fee/type', {         
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}